<div class="row">
    <div class="col mb-3">
        <img class="img-fluid mh-30-vh" src="../../../assets/img/blanco-amarillo.svg" alt="LoCana">
    </div>
</div>
<app-contact-form></app-contact-form>